jQuery( document ).ready( function($) {

	$( '.slide-banner' ).slick({
		arrows: false,
		fade: true,
		autoplay: true,
		dots: true
	});

	// reveal the menu
	$( '.j-show-menu' ).on( 'click', function(e) {
		e.preventDefault();

		$( '.navigation' ).addClass( 'slidein' );
	});

	// hide the menu
	$( '.j-hide-menu' ).on( 'click', function(e) {
		e.preventDefault();

		$( '.navigation' ).removeClass( 'slidein' );
	});

});